export default __webpack_public_path__ + "static/media/HG3-CC-S90-GC-2.6e74c4e1.jpg";